<template>
  <revit-demo />
</template>

<script>
import RevitDemo from "@/components/RevitDemo";

export default {
  name: "Home",

  components: {
    RevitDemo,
  },
};
</script>
